<div class="cs-list-holder slim-scroll thin cs-v5" #gridHolder>
    <div class="cs-list-wrapper cs-v5-style"
         [ngClass]="{'h-100': gridAutoHeightParams.gridLayout === 'normal', 'no-border-wrapper': !borderWrapper}"
         #gridWrapper>
        <div class="cs-list-header">
            <div class="cs-list-header__title" translate>{{ csListViewParams?.titleText }}</div>
            <div class="cs-list-header__action" *ngIf="isCustomHeaderAction || csListViewParams.actionBtnText">
                <ng-container *ngIf="isCustomHeaderAction; else defaultBtn">
                    <ng-content select="[headerAction]"></ng-content>
                </ng-container>

                <ng-template #defaultBtn>
                    <div class="default-action-btn">
                        <button class="btn btn-primary" (click)="defaultHeaderAction('add')" translate>{{csListViewParams.actionBtnText}}</button>
                    </div>
                </ng-template>
            </div>
        </div>
        <div class="cs-list-filter-panel" *ngIf="filterPanel">
            <div class="search">
                <app-cs-search-bar (onItemSearch)="onSearch($event)"></app-cs-search-bar>
            </div>
            <div class="filters" *ngIf="filterList">
                <app-filter
                    [widthChangeEvent]="filterWidthChangeEvent.asObservable()"
                    [availableFields]="filterList"
                    [appliedFilters]="appliedFilter"
                    (applyFilter)="onFilter($event, 'apply')"
                    (deleteFilter)="onFilter($event, 'remove')">
                </app-filter>
            </div>
        </div>
        <div class="cs-list" #grid>
            <ng-content select="[grid]"></ng-content>
        </div>
        <div class="cs-list-footer">
            <div class="cs-list-footer__pagination" *ngIf="totalRecordCount">
                <div class="cs-pagination-panel">
                    <app-cs-pagination-panel
                        [totalRecord]="totalRecordCount"
                        [maxPagesDisplayLength]="maxPagesDisplayLength"
                        [initialParams]="csListViewParams"
                        (onInit)="onPaginationInit($event)"
                        (onUpdatePagingParams)="updatePagingParams($event)">
                    </app-cs-pagination-panel>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="isDisplayPanel" class="display-panel-wrapper cs-v5-style" [appCsScrollbar]="">
        <ng-content select="[displayPanel]"></ng-content>
    </div>
</div>
